export default "__VITE_ASSET__DkAmkVBy__"